<template>
  <section class="vmp-media-setting__basic-setting">
    <main>
      <section class="vmp-media-setting-item" v-if="roleName == 1">
        <label class="vmp-media-setting-item__label">{{ $t('setting.setting_1035') }}</label>
        <vh-select
          class="vmp-media-setting-item__content"
          v-model="mediaState.rate"
          @change="rateChange(mediaState.rate)"
        >
          <vh-option
            v-for="rate in ratesConfig"
            :key="rate"
            :value="rate"
            :label="formatDefinitionLabel(rate)"
          ></vh-option>
        </vh-select>
      </section>

      <section class="vmp-media-setting-item">
        <label class="vmp-media-setting-item__label">{{ $t('setting.setting_1036') }}</label>
        <vh-select
          class="vmp-media-setting-item__content"
          v-model="mediaState.screenRate"
          :placeholder="$t('setting.setting_1048')"
        >
          <vh-option
            v-for="rate in screenRatesConfig"
            :key="rate.label"
            :value="rate.value"
            :label="rate.label"
          ></vh-option>
        </vh-select>
      </section>

      <section class="vmp-media-setting-item" v-if="!auth_gd">
        <label class="vmp-media-setting-item__label">{{ $t('setting.setting_1037') }}</label>
        <vh-select class="vmp-media-setting-item__content" v-model="mediaState.videoHint">
          <vh-option
            v-for="item in videoContentHint"
            :key="item.label"
            :value="item.value"
            :label="item.label"
          ></vh-option>
        </vh-select>
      </section>

      <section class="vmp-media-setting-item" v-if="roleName == 1 && !isPortraitLive && !auth_gd">
        <label class="vmp-media-setting-item__label vmp-media-setting-item__label-layout">
          {{ $t('setting.setting_1038') }}
        </label>
        <section class="vmp-media-setting-item__content">
          <div
            class="vmp-media-setting-item-layout__item"
            :class="{
              'vmp-media-setting-item-layout__item--selected': mediaState.layout === item.id,
              disabled: liveStatus === 1
            }"
            v-for="item of filterLayoutConfig"
            :key="item.id"
            @click="setLayout(item.id)"
          >
            <img :src="item.img" alt="" />
            <p>{{ item.text }}</p>
          </div>
        </section>
      </section>
      <section
        class="vmp-media-setting-item2"
        v-if="
          roleName == 1 &&
          liveMode != 1 &&
          !isPortraitLive &&
          !auth_gd &&
          mediaState.layout == 'CANVAS_ADAPTIVE_LAYOUT_GRID_MODE'
        "
      >
        <label class="vmp-media-setting-item__label-layout">
          {{ $t('setting.setting_1049') }}
          <vh-tooltip effect="dark" x :visible-arrow="false" placement="bottom">
            <i class="iconfont-v3 saasicon_help_m dialog__title__icon"></i>
            <div slot="content">
              {{ $t('setting.setting_1050') }}
              <br />
              {{ $t('setting.setting_1051') }}
            </div>
            <i class="iconfont-v3 saasicon_help_m dialog__title__icon"></i>
          </vh-tooltip>
        </label>
        <section class="vmp-media-setting-item__content noflex">
          <p class="title_tip">{{ $t('setting.setting_1052') }}</p>
          <vh-radio-group v-model="mediaState.layout_crop_type">
            <vh-radio :label="0" style="margin-bottom: 5px">
              {{ $t('setting.setting_1055') }}
            </vh-radio>
            <vh-radio :label="1">{{ $t('setting.setting_1054') }}</vh-radio>
          </vh-radio-group>
        </section>
      </section>
      <section
        class="vmp-media-setting-item"
        v-if="roleName == 1 && liveMode != 1 && !isPortraitLive && !auth_gd"
      >
        <label class="vmp-media-setting-item__label vmp-media-setting-item__label-layout">
          {{ $t('setting.setting_1056') }}
        </label>
        <section class="vmp-media-setting-item__content noflex">
          <p class="title_tip">
            {{ $t('setting.setting_1057') }}
            <vh-tooltip
              effect="dark"
              :content="$t('setting.setting_1058')"
              x
              :visible-arrow="false"
              placement="bottom"
            >
              <i class="iconfont-v3 saasicon_help_m dialog__title__icon"></i>
            </vh-tooltip>
          </p>
          <div
            class="vmp-media-setting-item-layout__item"
            :class="{
              'vmp-media-setting-item-layout__item--selected':
                mediaState.speaker_and_show_layout == 0,
              disabled: liveStatus === 1 || isConcise
            }"
            @click="setShowLayout(0)"
          >
            <img src="../../assets/img/inav_main_0.png" alt="" />
            <p>{{ $t('setting.setting_1059') }}</p>
          </div>
          <div
            class="vmp-media-setting-item-layout__item"
            :class="{
              'vmp-media-setting-item-layout__item--selected':
                mediaState.speaker_and_show_layout == 1,
              disabled: liveStatus === 1
            }"
            @click="setShowLayout(1)"
          >
            <img src="../../assets/img/inav_main_1.png" alt="" />
            <p>{{ $t('setting.setting_1060') }}</p>
          </div>
        </section>
      </section>
    </main>

    <footer>
      <section class="vmp-media-setting-tips">
        <section class="vmp-media-setting-tips__title">{{ $t('account.account_1061') }}：</section>
        <section class="vmp-media-setting-tips__title">{{ $t('setting.setting_1036') }}</section>
        <section class="vmp-media-setting-tips__content">
          <p>{{ $t('setting.setting_1061') }}</p>
          <p>{{ $t('setting.setting_1062') }}</p>
        </section>
        <section class="vmp-media-setting-tips__title" v-if="!auth_gd">
          {{ $t('setting.setting_1037') }}
        </section>
        <section class="vmp-media-setting-tips__content" v-if="!auth_gd">
          <p>{{ $t('setting.setting_1063') }}</p>
          <p>{{ $t('setting.setting_1064') }}</p>
        </section>
      </section>
    </footer>
  </section>
</template>

<script>
  import { useMediaSettingServer, useMsgServer } from 'middle-domain';
  import { LIVE_MODE_MAP } from '../../js/liveMap';
  import mediaSettingConfirm from '../../js/showConfirm';

  import FloatImg from '../../assets/img/float.png';
  import FloatRightImg from '../../assets/img/float_right.png';
  import TiledImg from '../../assets/img/tiled.png';
  import TiledReverseImg from '../../assets/img/tiled-reverse.png';
  import GridImg from '../../assets/img/grid.png';
  import TopSpeakerImg from '../../assets/img/top-speaker.png';
  export default {
    name: 'BasicSetting',
    data() {
      return {
        loading: false, // 读取中
        mediaState: this.mediaSettingServer.state,
        lastSelectRate: '', // 上一选中的画质的值（用于取消更改时还原）
        ratesConfig: Object.freeze([
          'RTC_VIDEO_PROFILE_720P_16x9_M', // 超清
          'RTC_VIDEO_PROFILE_480P_16x9_M', // 高清
          'RTC_VIDEO_PROFILE_360P_16x9_M', // 标清
          'RTC_VIDEO_PROFILE_240P_16x9_M' // 流畅
        ]),
        screenRatesConfig: Object.freeze([
          { value: 'RTC_SCREEN_PROFILE_1080P_16x9_H', label: this.$t('setting.setting_1040') },
          { value: 'RTC_SCREEN_PROFILE_1080P_16x9_M', label: this.$t('setting.setting_1041') }
        ]),
        videoContentHint: Object.freeze([
          { value: 'detail', label: this.$t('setting.setting_1042') },
          { value: 'motion', label: this.$t('setting.setting_1043') }
        ]),
        layoutConfig: Object.freeze([
          {
            id: 'CANVAS_ADAPTIVE_LAYOUT_FLOAT_MODE',
            img: FloatImg,
            text: this.$t('setting.setting_1044')
          },
          {
            id: 'CANVAS_ADAPTIVE_LAYOUT_FLOAT_RIGHT_MODE',
            img: FloatRightImg,
            text: this.$t('setting.setting_1069')
          },
          {
            id: 'CANVAS_ADAPTIVE_LAYOUT_TILED_MODE',
            img: TiledImg,
            text: this.$t('setting.setting_1045')
          },
          {
            id: 'CANVAS_ADAPTIVE_LAYOUT_GRID_MODE',
            img: GridImg,
            text: this.$t('setting.setting_1046')
          },
          {
            id: 'CANVAS_ADAPTIVE_LAYOUT_TILED_EXT1_MODE',
            img: TopSpeakerImg,
            text: this.$t('setting.setting_1047')
          }
        ]),
        LIVE_MODE_MAP,
        isPortraitLive: this.$domainStore.state.roomBaseServer?.webinarShowType == 0 // 竖屏直播
      };
    },
    computed: {
      // 是否是手机端 - 简洁模式  移动端模版选择了简洁风格会导致pc端分离模式不可用
      isConcise() {
        let skin_json_wap = {
          style: 1
        };
        const skinInfo = this.$domainStore.state.roomBaseServer.skinInfo;
        if (skinInfo?.skin_json_wap && skinInfo.skin_json_wap != 'null') {
          skin_json_wap = skinInfo.skin_json_wap;
        }
        return skin_json_wap?.style == 3;
      },
      webinar() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar;
      },
      // 角色：1-主持人；2-观众；3-助理；4-嘉宾
      roleName() {
        return this.$domainStore.state.roomBaseServer.watchInitData.join_info.role_name;
      },
      // 直播状态： 直播中、已结束....
      liveStatus() {
        return this.webinar.type;
      },
      // 直播类型：1-音频 2-视频 3-互动 6-互动
      liveMode() {
        return this.webinar.mode;
      },
      // 是否是无延迟
      isNoDelay() {
        return this.webinar.no_delay_webinar === 1;
      },
      // 在不同场景下的layoutConfig
      filterLayoutConfig() {
        // 分组、无延迟时，只展示一种布局
        const isGroupLive = this.liveMode === LIVE_MODE_MAP['GROUP'];

        // 分组时，主次布局是颠倒的，更换对应的img图片
        if (isGroupLive) {
          return this.layoutConfig
            .filter(item => item.id === 'CANVAS_ADAPTIVE_LAYOUT_TILED_MODE')
            .map(item => {
              item.img = TiledReverseImg;
              return item;
            });
        }

        if (this.isNoDelay) {
          return this.layoutConfig.filter(item => item.id === 'CANVAS_ADAPTIVE_LAYOUT_TILED_MODE');
        }

        return this.layoutConfig;
      },
      // guodu  权限
      auth_gd() {
        return this.$domainStore.state.roomBaseServer.embedSource == 'gd';
      }
    },
    watch: {
      'mediaState.rate': function (cur, old) {
        this.lastSelectRate = old;
      }
    },
    beforeCreate() {
      this.mediaSettingServer = useMediaSettingServer();
      this.msgServer = useMsgServer();
    },
    created() {
      this.listenEvents();
    },
    mounted() {
      this.setDefault();
    },
    beforeDestroy() {
      this.removeEvents();
    },
    methods: {
      listenEvents() {
        // 结束直播时恢复 标清
        this._onLiveOver = () => {
          this.mediaState.rate = this.ratesConfig[2]; // 恢复标清;
          sessionStorage.setItem('selectedRate', '');
        };
        this.msgServer.$on('live_over', this._onLiveOver);
      },
      removeEvents() {
        this.msgServer.$off('live_over', this._onLiveOver);
      },
      /**
       * 设置布局(layout)
       * @param {String} id
       */
      setLayout(id) {
        if (this.liveStatus === 1) return;
        this.mediaState.layout = id;
      },
      /**
       * 设置房间观看端布局/清晰度(speaker_and_show_layout )
       * @param {String} id
       */
      setShowLayout(id) {
        if (this.liveStatus === 1 || (this.isConcise && id == 0)) return;
        this.mediaState.speaker_and_show_layout = id;
      },
      /**
       * 应用默认选项
       */
      setDefault() {
        const saveRate = sessionStorage.getItem('selectedRate') || this.ratesConfig[2]; // 默认标清
        const saveScreenRate =
          sessionStorage.getItem('selectedScreenRate') || this.screenRatesConfig[1].value; // 默认PPT静态
        const videoHint = sessionStorage.getItem('videoHint') || this.videoContentHint[0].value; // 插播文件默认清晰度
        const savedLayout =
          this.mediaState.layout ||
          sessionStorage.getItem('layout') ||
          'CANVAS_ADAPTIVE_LAYOUT_TILED_MODE'; // 默认主次平铺

        this.mediaState.rate = saveRate;
        this.mediaState.screenRate = saveScreenRate;
        this.mediaState.videoHint = videoHint;
        this.mediaState.layout = savedLayout;
      },
      /**
       * 格式化清晰度(rate to text)
       * @param {String} label
       */
      formatDefinitionLabel(label) {
        const map = new Map([
          ['RTC_VIDEO_PROFILE_240P_16x9_M', 'setting.setting_1065'],
          ['RTC_VIDEO_PROFILE_480P_16x9_M', 'player.player_1003'],
          ['RTC_VIDEO_PROFILE_360P_16x9_M', 'player.player_1004'],
          ['RTC_VIDEO_PROFILE_720P_16x9_M', 'player.player_1005'],
          ['240', 'RTC_VIDEO_PROFILE_240P_16x9_M'],
          ['480', 'RTC_VIDEO_PROFILE_480P_16x9_M'],
          ['360', 'RTC_VIDEO_PROFILE_360P_16x9_M'],
          ['720', 'RTC_VIDEO_PROFILE_720P_16x9_M']
        ]);
        return this.$t(map.get(label));
      },
      /**
       * 更改清晰度
       * @notes 如果选择的是超清，会进行弹窗询问，如果取消则会还原选择前的值
       * @param {String} selected
       */
      async rateChange(selected) {
        if (selected === 'RTC_VIDEO_PROFILE_720P_16x9_M') {
          const text = this.$t('setting.setting_1066');
          const action = await mediaSettingConfirm.show(text);
          action === 'close' && (this.mediaState.rate = this.lastSelectRate);
        }
      }
    }
  };
</script>

<style lang="less">
  .vmp-media-setting__basic-setting {
    .vmp-media-setting-item-layout__item {
      padding-bottom: 10px;
    }
    .vmp-media-setting-item__label-layout {
      height: 46px;
      font-size: 14px;
    }
    .vmp-media-setting-item2 {
      margin-bottom: 16px;
    }
    .vmp-media-setting-item__content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      &.noflex {
        display: block;
        .vmp-media-setting-item-layout__item {
          width: 68px;
          display: inline-block;
          margin-right: 6px;
        }
      }

      .title_tip {
        color: #8c8c8c;
        font-size: 14px;
        margin-bottom: 8px;
        i {
          cursor: pointer;
        }
      }
      .vmp-media-setting-item-layout__item {
        background-size: 100%;
        user-select: none;
        cursor: pointer;

        &.disabled {
          cursor: not-allowed;
        }

        img {
          border: 1px solid #c4c4c4;
          border-radius: 3px;
          width: 68px;
          height: 46px;
          user-select: none;
          pointer-events: none;
        }

        &--selected {
          img {
            border: 1px solid #fb3a32;
          }
        }

        p {
          margin-top: 2px;
          color: #666;
          font-size: 12px;
          text-align: center;
          white-space: nowrap;
        }
      }
    }
    .vmp-media-setting-tips {
      margin-top: -26px;
      .vmp-media-setting-tips__content {
        margin-bottom: 8px;
      }
    }
  }
</style>
